import { FC } from 'react';
import { FormikProps } from 'formik';
import AssigneeSelector from 'containers/assignee-selector';

interface AssigneeStepProps {
  form: FormikProps<{
    category: string;
    details: string;
    assigneeType: 'group' | 'user';
    assigneeId: number;
    assigneeName: string;
  }>;
}

const AssigneeStep: FC<AssigneeStepProps> = ({ form }) => {
  return <AssigneeSelector form={form} />;
};

export default AssigneeStep;
